export default __webpack_public_path__ + "static/media/access_time_white.adeda37e.svg";